import { isEmpty } from 'lodash'
import notification from 'modules/app-core/notification-manager'
import { createRequest } from 'modules/redux-gateway'

import t from './actionTypes'
import { TAGS_GET, TAGS_DELETE, TAGS_POST } from './constants'

export const editTags = (str) => ({
  type: t.EDIT_TAGS,
  payload: str,
})
export const changeTags = (tags, id) => ({
  type: t.CHANGE_TAGS,
  payload: { tags, id },
})
export const loadTags = (tags, id) => ({
  type: t.LOAD_TAGS,
  payload: { tags, id },
})
export const updatingTags = (id) => ({
  type: t.UPDATING_TAGS,
  payload: id,
})
const updateTagDone = (tag) => ({
  type: t.UPDATING_TAG_DONE,
  payload: tag,
})

const updateTagsDone = (id) => (dispatch, getState) => {
  const state = getState()
  const stateTags = state.tags.tags[id].tags
  stateTags.forEach((tag) => dispatch(updateTagDone(tag)))
}

export const fetchAllTags =
  (itemPublicKeys, ItemType, forceGet = false) =>
  (dispatch) => {
    // getTags
    if (forceGet || itemPublicKeys.length > 0) {
      dispatch(
        createRequest({
          route: TAGS_GET,
          params: {
            ItemType,
            ItemPublicKeys: JSON.stringify(itemPublicKeys),
          },
        })
      ).then(
        (rawResponse) => {
          let response = {}
          rawResponse.forEach((raw) => {
            response = { ...response, ...raw }
          })
          Object.keys(response).forEach((tag) => {
            const responseTag = response[tag].map((rt) => ({
              ...rt,
              name: rt.Tag,
              IsActive: rt.IsActive || true,
            }))
            dispatch(loadTags(responseTag, tag))
          })
        },
        () => {
          dispatch(
            notification.actions.createErrorNotification(
              'Sorry, there was an error getting Tags.'
            )
          )
        }
      )
    }
  }

const postTags = (Tags, ItemPublicKey, ItemType) => (dispatch) => {
  dispatch(
    createRequest({
      route: TAGS_POST,
      body: {
        ItemType,
        ItemPublicKey,
        Tags,
      },
    })
  ).then(
    (response) => {
      if (response === 'Success') {
        dispatch(updateTagsDone(ItemPublicKey))
        // refresh tags
        dispatch(fetchAllTags([ItemPublicKey], ItemType))
        return
      }
      dispatch(
        notification.actions.createErrorNotification(
          'Sorry, there was an error posting Tags.'
        )
      )
      dispatch(updateTagsDone(ItemPublicKey))
    },
    () => {
      dispatch(
        notification.actions.createErrorNotification(
          'Sorry, there was an error posting Tags.'
        )
      )
      dispatch(updateTagsDone(ItemPublicKey))
    }
  )
}

const deleteTag = (TagPublicKey) =>
  createRequest({
    route: TAGS_DELETE,
    params: {
      TagPublicKey,
    },
  })

export const updateTags = (id) => (dispatch, getState) => {
  const state = getState()
  const tags = state.tags.tags[id].tags
  dispatch(updatingTags(id))
  const postingTags = {}
  tags.forEach((tag) => {
    if (tag.isChanged) {
      if (tag.IsActive === false) {
        dispatch(deleteTag(tag.Id)).then(
          (response) => {
            if (response === 'Success') {
              dispatch(updateTagDone(tag))
              return
            }
            dispatch(
              notification.actions.createErrorNotification(
                'Sorry, there was an error posting Tags.'
              )
            )
            dispatch(updateTagDone(tag))
          },
          () => {
            dispatch(
              notification.actions.createErrorNotification(
                'Sorry, there was an error posting Tags.'
              )
            )
            dispatch(updateTagDone(tag))
          }
        )
      } else if (tag.IsActive) {
        if (!postingTags[tag.ItemPublicKey]) {
          postingTags[tag.ItemPublicKey] = []
        }
        if (!postingTags[tag.ItemPublicKey][tag.ItemType]) {
          postingTags[tag.ItemPublicKey][tag.ItemType] = []
        }
        postingTags[tag.ItemPublicKey][tag.ItemType].push(tag.name)
      }
    }
  })
  if (!isEmpty(postingTags)) {
    Object.keys(postingTags).forEach((ipk) => {
      Object.keys(postingTags[ipk]).forEach((it) =>
        dispatch(postTags(postingTags[ipk][it], ipk, it))
      )
    })
  }
}
